"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when unable to set value on object via setKey()
 * @param {string} explanation
 */
class SetValueOnObjectError extends ExtendableError_1.default {
    constructor(explanation, key) {
        super(`Could not set value on ${key}, because: ${explanation}`);
        this.explanation = explanation;
        this.key = key;
    }
}
exports.default = SetValueOnObjectError;
